export default "__VITE_ASSET__5540c7ac__"